import { Injectable, Injector } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApplicationConstants, HttpStatusCode } from '../../../../constants/application.constants';
import { isStringNullUndefinedOrEmptyWithTrim } from '../../../../utility';
import { HttpClientService } from '../../http/http-client-data/http-client-service';
import { GeneralTablesResponse } from 'src/app/models/general-tables';
import { ProsPlanProgramIds } from './general-tables.constants'

@Injectable({
  providedIn: 'root'
})
export class GeneralTablesService extends HttpClientService {
  constructor(protected injector: Injector) {
    super(injector, ApplicationConstants.dataServiceClientIDs.generalTablesDataService);
  }

  getProgramTypeCode(networkId: string): Observable<string | undefined> {
    if (isStringNullUndefinedOrEmptyWithTrim(networkId)) {
      console.error('General tables lookup requires a network id.');

      return of(undefined);
    }

    return this.getGeneralTablesResponse(networkId).pipe(
      map((generalTablesResponse: GeneralTablesResponse) => {
        const programTypeCode = this.extractProgramTypeCode(generalTablesResponse);

        if (!programTypeCode) {
          console.error('General tables endpoint returned an invalid response shape');
          return undefined;
        }

        return programTypeCode;
      }),
      catchError((error: any) => {
        console.error('Error calling General tables endpoint', error);
        if (error?.status === HttpStatusCode.BadRequest || error?.status === HttpStatusCode.Forbidden) {
          this.messageService.showErrorSnackbar(ApplicationConstants.errorMessages.genericApiFailMessage);
        }

        return of(undefined);
      }),
    );
  }

  private getGeneralTablesResponse(networkId: string): Observable<GeneralTablesResponse> {
    const params = new HttpParams()
      .set('table', ProsPlanProgramIds)
      .set('code', networkId.trim());

    return this.http.get<GeneralTablesResponse>(
      `${this.environment.generalTablesUrl}${ApplicationConstants.api.generalTablesCodesEndpoint}`,
      {
        params,
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      }
    );
  }

  private extractProgramTypeCode(generalTablesResponse: GeneralTablesResponse): string | undefined {
    if (!generalTablesResponse || generalTablesResponse.length < 1) {
      return undefined;
    }

    return generalTablesResponse[0]?.fields?.ProgramTypeCode?.trim();
  }
}
